import Controller from './Controller'
import View from './View'

export default {
	controller: Controller,
	name: 'Boolean',
	view: View,
}
